<template>
  <div class="main">
    <a-spin class="load"
            v-show="loading"/>
    <!--    <div class="top">-->
    <!--      <span class="icon"-->
    <!--            @click="history"><img class="historyImg"-->
    <!--             src="../../../assets/image/08.png"-->
    <!--             alt=""></span>-->
    <!--      <span class="iconText">备课资源</span>-->
    <!--    </div>-->
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item style="font-size: 16px">
          <router-link :to="'/books/writingGuide'">写作指导</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px">备课资源</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="content">
      <a-tabs default-active-key="1" @change="callback" class="tab">
        <a-tab-pane key="1" tab="系统资源">
          <div class="list">
            <a-list item-layout="vertical"
                    size="large"
                    :pagination="pagination"
                    :data-source="listData">
              <a-list-item slot="renderItem"
                           key="item.title"
                           class="item"
                           slot-scope="item">
                <a-list-item-meta :description="item.description">
                  <div slot="title">
                    <a-row>
                      <a-col :span="17">
                        <span class="name"><img src="../../../assets/image/tubiao1.png" alt=""></span>
                        <span class="className">素养植根专家团队</span>
                      </a-col>
                      <a-col :span="7"
                             style="text-align:right;">
                        <!-- <span v-if="item.objectType==1"
                              class="sysRec">* 系统推荐</span> -->
                        <span class="useNum">已被使用 {{ item.useCount ? item.useCount : '0' }} 次</span>
                        <a-button class="useTo"
                                  @click="useStudyRecommand(item)"
                                  :disabled="item.selected==true?false:true">使用
                        </a-button>
                      </a-col>
                    </a-row>
                  </div>
                  <!-- <a-avatar class="avatar"
                            slot="avatar"
                            :src="$userINfoBasePath+item.userPhoto" /> -->
                </a-list-item-meta>
                <div>
                  <p class="guideTitle">{{ item.title }}</p>
                  <p class="prepare-content" style="margin-top:10px;"
                     v-html="item.guideContent.trim()">
                  </p>
                </div>
                <!-- <template :slot-scope="item.activityDTOS">
              <ul class="ulList">
                  <li class="listMes" v-for="(item, index) in item.activityDTOS" :key="index">
                      <img style="width:16px;height:16px;" src="../../../assets/image/31.png" alt="">
                      <span class="text">{{item.activityContent}}</span>
                  </li>
              </ul>
          </template> -->
              </a-list-item>
            </a-list>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2"
                    tab="优质资源"
                    force-render>
          <div class="list">
            <a-list item-layout="vertical"
                    size="large"
                    :pagination="pagination"
                    :data-source="listDatas">
              <a-list-item slot="renderItem"
                           key="item.title"
                           class="item"
                           slot-scope="item">
                <a-list-item-meta :description="item.description">
                  <div slot="title">
                    <a-row>
                      <a-col :span="17">
                        <span class="name">{{ item.name }}</span>
                        <span class="className">{{ item.className }}</span>
                      </a-col>
                      <a-col :span="7"
                             style="text-align:right;">
                      <span v-if="item.objectType==1"
                            class="sysRec">✨ 系统推荐</span>
                        <span class="useNum">已被使用 {{ item.useCount ? item.useCount : '0' }} 次</span>
                        <a-button class="useTo"
                                  @click="useStudyRecommand(item)"
                                  :disabled="item.selected2==true?false:true">使用
                        </a-button>
                      </a-col>
                    </a-row>
                  </div>
                  <a-avatar class="avatar"
                            slot="avatar"
                            :src="$userINfoBasePath+item.userPhoto"/>
                </a-list-item-meta>
                <div>
                  <p class="guideTitle">{{ item.title }}</p>
                  <p class="prepare-content" style="margin-top:10px;"
                     v-html="item.guideContent.trim()">
                  </p>
                </div>
              </a-list-item>
            </a-list>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3"
                    tab="用户资源">
          <div class="list">
            <a-list item-layout="vertical"
                    size="large"
                    :pagination="pagination"
                    :data-source="listDatas_use">
              <a-list-item slot="renderItem"
                           key="item.title"
                           class="item"
                           slot-scope="item">
                <a-list-item-meta :description="item.description">
                  <div slot="title">
                    <a-row>
                      <a-col :span="17">
                        <span class="name">{{ item.userName }}</span>
                        <span class="className">{{ item.className }}</span>
                      </a-col>
                      <a-col :span="7"
                             style="text-align:right;">
                        <!-- <span v-if="item.objectType==1"
                              class="sysRec">✨ 系统推荐</span> -->
                        <span class="useNum">已被使用 {{ item.useCount ? item.useCount : '0' }} 次</span>
                        <a-button class="useTo"
                                  @click="useStudyRecommand(item)"
                                  :disabled="item.selected1==true?false:true">使用
                        </a-button>
                      </a-col>
                    </a-row>
                  </div>
                  <a-avatar class="avatar"
                            slot="avatar"
                            :src="$userINfoBasePath+'/'+item.photo"/>
                </a-list-item-meta>
                <div>
                  <p class="guideTitle">{{ item.title }}</p>
                  <p class="prepare-content" style="margin-top:10px;"
                     v-html="item.guideContent.trim()">
                  </p>
                </div>
                <!-- <template :slot-scope="item.activityDTOS">
              <ul class="ulList">
                  <li class="listMes" v-for="(item, index) in item.activityDTOS" :key="index">
                      <img style="width:16px;height:16px;" src="../../../assets/image/31.png" alt="">
                      <span class="text">{{item.activityContent}}</span>
                  </li>
              </ul>
          </template> -->
              </a-list-item>
            </a-list>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
// import HanIcon from 'components/Icon.vue'
export default {
  name: 'WritingRecommend',
  data() {
    return {
      loading: false,
      resBasePath: this.$resBasePath,
      pagination: {
        onChange: page => {
          console.log(page)
        },
        pageSize: 3,
      },
      listData: [],
      listDatas: [],
      listDatas_use: [],
      indexNum: ''
    }
  },
  components: {},
  created() {

  },
  watch: {
    mlVisible() {

    }
  },
  mounted() {
    this.getList()
    // this.getLists()
    // this.getLists_use()
  },
  methods: {
    callback(key) {
      switch (key) {
        case '1':
          this.getList()
          break
        case '2':
          this.getLists()
          break
        case '3':
          this.getLists_use()
          break
      }
    },
    getList(index) { ///teacher/task/getRecommendTask
      const param = {
        pageNum: 1,
        pageSize: 10,
        bookId: localStorage.getItem('syzg-bookId'),
        styleId: localStorage.getItem('styleId'),
        school: "", // 教师所在学校
        objectType: 1
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/guide/getRecommendWritingGuide',
        body: param
      }).loading(
          () => (this.laoding = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.listData = res.resultData.list.map((item, index) => ({...item, index}))
          this.listData.forEach(item => {
            item['selected'] = true
            if (item.index == index) {
              item['selected'] = false
            }
          })
        }
      })
    },
    getLists(index) { ///teacher/task/getRecommendTask
      const param = {
        pageNum: 1,
        pageSize: 10,
        bookId: localStorage.getItem('syzg-bookId'),
        styleId: localStorage.getItem('styleId'),
        school: "", // 教师所在学校
        objectType: 5
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/guide/getRecommendWritingGuide',
        body: param
      }).loading(
          () => (this.laoding = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.listDatas = res.resultData.list.map((item, index) => ({...item, index}))
          this.listDatas.forEach(item => {
            item['selected2'] = true
            if (item.index == index) {
              item['selected2'] = false
            }
          })
        }
      })
    },
    getLists_use(index) { ///teacher/task/getRecommendTask
      const param = {
        pageNum: 1,
        pageSize: 10,
        bookId: localStorage.getItem('syzg-bookId'),
        styleId: localStorage.getItem('styleId'),
        school: "", // 教师所在学校
        objectType: 3
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/guide/getRecommendWritingGuide',
        body: param
      }).loading(
          () => (this.laoding = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.listDatas_use = res.resultData.list.map((item, index) => ({...item, index}))
          this.listDatas_use.forEach(item => {
            item['selected1'] = true
            if (item.index == index) {
              item['selected1'] = false
            }
          })
        }
      })
    },
    useStudyRecommand(item) { // teacher/task/useRecommendTask
      const param = {
        id: item.id,
        teacherId: this.$getUserInfo().id,
        school: "" // 教师所在学校
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/guide/useOthersWritingGuide',
        body: param
      }).loading(
          () => (this.laoding = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success("使用成功")
          this.getList(item.index)
          this.getLists(item.index)
          this.getLists_use(item.index)
        }
      })
    },
    history() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.sysRec {
  color: @primary-color;
  font-size: 14px;
  margin-right: 10px;
}

.ant-col-4 {
  width: 20.666667%;
  float: right;
}

.main {
  // height: 110px;
  // background-color: #fff;
  margin-left: -205px;

  .breadcrumb {
    width: 1240px;
    margin: 0 auto;
  }

  .top {
    height: 50px;
    background-color: #fff;
    width: 1240px;
    margin: 0 auto;
    position: relative;

    .historyImg {
      width: 8px;
      height: 16px;
      cursor: pointer;
    }

    .icon {
      position: absolute;
      top: 50%;
      margin-top: -7px;
      left: 50px;
    }

    .iconText {
      position: absolute;
      top: 50%;
      margin-top: -10px;
      left: 70px;
      color: #9d9292;
      font-size: 18px;
    }
  }

  .breadcrumb {
    margin-bottom: 20px;
  }

  .content {
    // min-height: 1200px;
    //  background: #fff;
    width: 1240px;
    margin: 20px auto;
    height: calc(100vh - 185px);

    .tab {
      padding-bottom: 20px;
    }

    .list {
      overflow-y: auto;
      height: calc(100vh - 255px);
    }

    .item {
      background: #F1F0F0;
      border-radius: 6px;
      padding: 20px;
      margin: 20px;
    }


    .guideTitle {
      font-family: PingFangSC-Regular;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 34px;
      letter-spacing: 0px;
      color: #040506;
    }

    .name,
    .className,
    .useNum,
    .useTo {
      letter-spacing: 0px;
      color: #9d9292;
      font-size: 14px;

      img {
        width: 40px;
        height: auto;
      }
    }

    .className {
      margin-left: 10px;
    }

    .useTo {
      display: inline-block;
      width: 80px;
      height: 30px;
      background-color: @primary-color;
      color: #fff;
      margin-left: 20px;
    }

    .avatar {
      width: 25px;
      height: 25px;
    }

    .contentMes {
      font-family: PingFangSC-Regular;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #040506;
    }

    .ulList {
      padding: 0;
      margin-top: 10px;
      list-style: none;

      .listMes {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #9d9292;
        height: 30px;
        line-height: 30px;

        .text {
          margin-left: 15px;
        }
      }
    }
  }

  .prepare-content {
    width: 100%;
    height: 100%;
    // background-color: white;
    border-radius: @border-radius-base;
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #040506;
    white-space: pre-wrap;
    font-weight: normal;
    font-stretch: normal;
  }
}

/deep/ .ant-list-pagination {
  text-align: center;
  padding-bottom: 20px;
  margin-bottom: 10px;
}

.books-router ant-layout-content {
  padding-left: 20px;
}

/deep/ .ant-list-vertical .ant-list-item-meta {
  margin-bottom: 0px;
}

/deep/ .ant-list-something-after-last-item
.ant-spin-container
> .ant-list-items
> .ant-list-item:last-child {
  // border-bottom: 10px solid #f1f0f0;
}

/deep/ .ant-tabs-nav-scroll {
  border-bottom: 2px solid #F1F0F0;
}

/deep/ .ant-list-empty-text {
  background: #FFFFFF;
  border-radius: 10px;
}

/deep/ .ant-list-split .ant-list-item {
  //border-bottom: 10px solid #f1f0f0;
  padding: 20px 30px 20px 30px;
  border-radius: 10px;
  background: #FFFFFF;
  margin-bottom: 10px;
}

/deep/ .ant-tabs {
  background: #FFFFFF;
  border-radius: 10px;
}

</style>
